const getIsCaching = s => s.debug.isCaching
const getLogStats = s => s.debug.logStats
const getWidgetDiagnostics = s => s.debug.widgetDiagnostics
const getWidgetCacheById = id => s => s.debug.widgetCache[id]

export const debugSelectors = { getIsCaching, getLogStats, getWidgetDiagnostics, getWidgetCacheById }
